module.exports = __webpack_public_path__ + "static/media/g-4-a.fc0bee90.jpg";